<template>
  <div class="invite">
    <ui-autocomplete
      @open="listOpen"
      @close="listClose"
      loose
      :items="contactAvatarList"
      :on-item-selected="onItemSelected"
      :placeholder="i18n.t('inviteFriendsPlaceholder')"
      show-on-focus
      v-model="invite"
      :filter-data="true"
      @enter="enterHandler"
      ref="inviteInput"
    >
    </ui-autocomplete>
    <ui-hr v-if="inviteList.length"> <ui-icon name="team"></ui-icon> </ui-hr>
    <ui-row v-if="inviteList">
      <ui-tag
        :show-close="true"
        v-ui-tooltip="inviteTip(item)"
        size="sm"
        :key="item.email"
        v-for="(item, index) of inviteList"
        @close="removeInvite(index)"
        :type="tagType(item.status)"
      >
        <ui-avatar
          size="sm"
          :url="item.avatar"
          :username="
            item.username ? item.username + ' ' + item.email : item.email
          "
        ></ui-avatar>
      </ui-tag>
    </ui-row>
    <ui-accordion v-if="inviteList.length">
      <ui-accordion-item :title="i18n.t('invatationLetter')">
        <ui-textarea v-model="invatationLetter"></ui-textarea>
      </ui-accordion-item>
    </ui-accordion>
  </div>
</template>
<script>
import api from "../api/index.js";
import { validator } from "../utils/utils.js";
import uniqueArray from "../utils/unique.js";
import renderAvatar from "../utils/renderAvatar.js";
import i18n from "../locale/i18n.js";

export default {
  name: "invite",

  data() {
    return {
      inviteList: [],
      invite: null,
      contactAvatarList: [],
      invatationLetter: i18n.t("invatationLetterContent"),
      contactList: [],
      isListOpened: false,
      i18n: i18n
    };
  },
  props: {
    book: Object,
    authInfo: Object
  },
  methods: {
    inviteTip(item) {
      if (!item.status || status == "pending") {
        return null;
      }
      if (item.status == "finished") {
        return { content: i18n.t("inviteSuccessed"), insertAfter: false };
      }
      if (item.status == "failed") {
        return { content: i18n.t("inviteFailedEmail"), insertAfter: false };
      }
    },
    tagType(status) {
      if (!status || status == "pending") {
        return "border";
      }
      if (status == "finished") {
        return "success";
      }
      if (status == "failed") {
        return "warning";
      }
    },
    listOpen() {
      this.isListOpened = true;
    },
    listClose() {
      this.isListOpened = false;
    },
    sendInvites() {
      if (this.inviteList.length) {
        api
          .bookInvite({
            bookId: this.book.id,
            inviteList: this.inviteList.map(item => item["email"]),
            letter: this.invatationLetter
          })
          .then(() => {
            this.$UiToast(i18n.t("invaiteSendSuccessed"));
            this.$emit("send-success");
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.$emit("close");
      }
    },
    removeInvite(index) {
      api
        .removeBookInvite({
          email: this.inviteList[index].email,
          bookId: this.book.id
        })
        .then(res => {})
        .catch(err => {
          console.log(err);
        });
      this.inviteList.splice(index, 1);
    },
    isInvited(email) {
      return this.inviteList.map(i => i["email"]).includes(email);
    },
    isInContact(email) {
      return this.contactList.map(c => c["email"]).includes(email);
    },
    addInvite(email) {
      this.invite = null;
      if (this.authInfo.email == email) {
        return this.$UiToast(i18n.t("cannotInviteYouself"));
      }
      if (!this.isInContact(email)) {
        this.addToContact(email);
      }
      if (!this.isInvited(email)) {
        this.getUserInfo(email).then(userInfo => {
          this.inviteList.push(userInfo ? userInfo : { email: email });
        });
      }
    },
    getUserInfo(email) {
      return new Promise((resolve, reject) => {
        api.getUserInfo(email).then(res => {
          resolve(res.data);
        });
      });
    },
    addToContact(email) {
      api
        .addContact({
          email: email,
          type: "bookInvite"
        })
        .then();
    },
    enterHandler(query) {
      if (this.isListOpened) {
        return;
      }
      if (!validator.email.test(query)) {
        this.$UiToast.error(i18n.t("typeValidEmail"));
      } else {
        this.addInvite(query);
      }
    },
    onItemSelected(index) {
      let email = this.contactList[index].email;
      this.addInvite(email);
    },
    setItems() {
      this.contactList.forEach(item => {
        item.el = renderAvatar({
          url:
            item.userInfo && item.userInfo.avatar ? item.userInfo.avatar : "",
          username: item.userInfo
            ? item.userInfo.username + " " + item.email
            : item.email
        });
      });
      this.contactAvatarList = this.contactList.map(c => c["el"]);
    }
  },
  mounted() {
    api.getContactList().then(res => {
      this.contactList = res.data.contactList;
      this.setItems();
    });
    api
      .getInviteList(this.book.id)
      .then(res => {
        this.inviteList = res.data;
      })
      .catch(err => {});
  }
};
</script>
<style lang="scss" scoped>
.ui-row {
  > .ui-tag {
    margin: 0.5em;
  }
}
</style>
